// Norsk formattering (nb-NO)

export const fmtNOK = (n, opts = {}) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("nb-NO", {
    style: "currency",
    currency: "NOK",
    minimumFractionDigits: opts.decimals ?? 0,
    maximumFractionDigits: opts.decimals ?? 0,
  }).format(Number(n));
};

export const fmtNumber = (n, decimals = 0) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("nb-NO", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(Number(n));
};

export const fmtKwh = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const val = Number(n);
  if (val >= 1_000_000) return `${fmtNumber(val / 1_000_000, 2)} GWh`;
  if (val >= 1000) return `${fmtNumber(val / 1000, 1)} MWh`;
  return `${fmtNumber(val, 0)} kWh`;
};

export const fmtOre = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return `${fmtNumber(n, 2)} øre/kWh`;
};

export const fmtDate = (d) => {
  if (!d) return "—";
  try {
    const dt = typeof d === "string" ? new Date(d) : d;
    return new Intl.DateTimeFormat("nb-NO", {
      year: "numeric", month: "short", day: "2-digit",
    }).format(dt);
  } catch { return "—"; }
};

export const fmtDateTime = (d) => {
  if (!d) return "—";
  try {
    const dt = typeof d === "string" ? new Date(d) : d;
    return new Intl.DateTimeFormat("nb-NO", {
      year: "numeric", month: "short", day: "2-digit",
      hour: "2-digit", minute: "2-digit",
    }).format(dt);
  } catch { return "—"; }
};

export const relativeDays = (d) => {
  if (!d) return "";
  const dt = new Date(d);
  const diff = Math.floor((dt.getTime() - Date.now()) / 86400000);
  if (diff === 0) return "i dag";
  if (diff === 1) return "i morgen";
  if (diff === -1) return "i går";
  if (diff < 0) return `${-diff} dager siden`;
  return `om ${diff} dager`;
};

export const contractTypeLabel = (t) => ({
  spot: "Spot",
  spot_paaslag: "Spot + påslag",
  fastpris: "Fastpris",
  variabel: "Variabel",
  norgespris: "Norgespris",
  bedrift: "Bedrift",
  skreddersydd: "Skreddersydd",
}[t] || t);

export const invoiceStatusLabel = (s) => ({
  utkast: "Utkast",
  sendt: "Sendt",
  betalt: "Betalt",
  delvis_betalt: "Delvis betalt",
  purret: "Purret",
  inkasso: "Inkasso",
  kreditert: "Kreditert",
}[s] || s);

export const caseStatusLabel = (s) => ({
  ny: "Ny",
  under_arbeid: "Under arbeid",
  venter_kunde: "Venter på kunde",
  lost: "Løst",
  lukket: "Lukket",
}[s] || s);

export const roleLabel = (r) => ({
  superadmin: "Superadmin",
  admin: "Administrator",
  kundeservice: "Kundeservice",
  okonomi: "Økonomi",
  drift: "Drift",
  bedriftsbruker: "Bedriftsbruker",
  viewer: "Leser",
}[r] || r);
